// Category B/C public analytics identifiers and public refs.
// Source of truth: this file. Do NOT add these identifiers to vault.
// Classification policy: docs/vault/CLASSIFICATION.md
// Last updated: 2026-05-22 (vault-hygiene migration)

export const PUBLIC_ANALYTICS_IDS = {
  ga4MeasurementId: "G-H1FDXT4FY0",
  ga4PropertyId: "515476883",
  posthogKey: "phc_TUfnWl2T4CcqWzoExlCSHVrKXxsggBkhn3SqywvGTLc",
} as const;

// Production hostnames whose browser traffic is the ONLY traffic allowed to reach
// the production GA4 property. Staging (staging.bizrnr.com), Vercel preview deploys
// (*.vercel.app), and local/CI (localhost / 127.0.0.1) all ship the same
// NEXT_PUBLIC_GA4_ID; without this allowlist every preview build + E2E run pollutes
// the property (observed Jun 4 2026: 1,338 of 1,365 sessions were non-prod hosts).
export const PRODUCTION_ANALYTICS_HOSTS = ["bizrnr.com", "www.bizrnr.com"] as const;

/**
 * True only when `hostname` is a canonical production host. Used to gate every
 * GA4 emission path (client gtag loader, client MP beacon, server /api/collect)
 * so non-production environments never write into the prod analytics property.
 */
export function isProductionAnalyticsHost(hostname: string | null | undefined): boolean {
  if (!hostname) return false;
  return (PRODUCTION_ANALYTICS_HOSTS as readonly string[]).includes(
    hostname.toLowerCase().trim(),
  );
}
